import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import request from '../../../request';

export default class DeleteStudy extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor() {
    super();
    this.state = {};
  }

  async delete() {
    let { id, type, redirect } = this.props;
    this.setState({ loading: true });

    try {
      await request({
        url: `studies/${id}/${type || ''}`,
        method: 'DELETE',
      });
      this.context.router.history.push(redirect || '/');
    } catch (error) {
      this.setState({ error: error.message, loading: false });
    }
  }

  render() {
    let { id, message, type } = this.props;
    let { loading } = this.state;

    return (
      <div id="edit" className="edge" style={{ opacity: loading ? 0.5 : 1 }}>
        <h5 className="heading">Delete {type || 'study'}</h5>
        <p>
          {message ||
            "Are you sure you want to remove the entire study from the system? This will remove the study record, as well as any results or reports. You can't undo this."}
        </p>
        <div id="dashboard">
          <div className="options">
            <button
              id="confirm"
              className="action primary"
              type="submit"
              onClick={() => this.delete()}
            >
              Confirm
            </button>
            <Link className="action" to={`/study/${id}`}>
              Cancel
            </Link>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/dashboard/components/delete-study.js